module.exports = __webpack_public_path__ + "img/102.8.f6c4a01e.png";